<template>
  <div
    class="card-body col-8 pt-0 p-3 mx-auto"
    style="cursor: pointer"
    @click="handleClick"
  >
    <ul class="list-group">
      <li
        class="list-group-item border-0 d-flex flex-wrap p-3 mb-1 border-radius-lg align-items-center justify-content-between"
        style="background-color: rgb(230, 230, 230); cursor: pointer"
      >
        <div class="col p-2">
          <span class="text-lg">
            {{ $t("Line Name") }}
          </span>
          <div
            onmouseover="style.textDecoration = 'underline'"
            onmouseout="style.textDecoration = 'none'"
          >
            <h6 class="text-2xl">{{ lineName }}</h6>
          </div>
        </div>
        <div class="d-flex flex-column flex-md-row align-items-center ms-auto gap-4">
          <div>
            <span
              class="me-2"
              style="font-size: 0.9rem"
            >
              PLC <span style="font-size: 0.8rem">connection</span>
            </span>
            <span class="badge badge-dot">
              <i
                :style="{
                  width: '13px',
                  height: '13px',
                  display: 'inline-block',
                  borderRadius: '50%',
                  backgroundColor: plcStatusColor,
                }"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                :title="plcStatusTooltip"
                data-container="body"
                data-animation="true"
              >
              </i>
            </span>
          </div>
          <div
            v-if="!$store.state.finetune_license"
            class="text-end"
            @click.stop="$router.push({ name: 'LineDetailSteelCase', params: { lineId: lineId } })"
          >
            <a
              class="btn btn-link text-dark mb-0 my-auto w-100"
              style="white-space: nowrap"
            >
              <i
                class="fas fa-pencil-alt text-dark me-2"
                aria-hidden="true"
              ></i>
              Edit
            </a>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { Tooltip } from 'bootstrap';

export default {
  name: "LineCardSteelCase",
  props: {
    lineName: {
      type: String,
      default: "",
    },
    lineId: {
      type: String,
      default: "",
    },
    plcConnectionStatus: {
      type: String,
      default: "",
    },
    plcConnectionStatusCreatedAt: {
      type: String,
      default: "",
    },
  },
  data() {
    this.$i18n.locale = this.$store.state.user_data.language;
    return {};
  },
  mounted() {
    this.initTooltips();
  },
  updated() {
    this.initTooltips();
  },
  computed: {
    plcStatusColor() {
      if (!this.plcConnectionStatus) {
        return "darkgrey";
      }
      switch (this.plcConnectionStatus) {
        case "Connected":
          return "green";
        case "Disconnected":
          return "red";
        case "NoConnectionSetup":
          return "darkgrey";
        case "CheckFailed":
          return "yellow";
        default:
          return "darkgrey";
      }
    },
    plcStatusTooltip() {
      if (!this.plcConnectionStatus) {
        return "PLC Connection Unknown";
      }
      const last_checked_str = `Last checked: ${this.plcConnectionStatusCreatedAt}.`
      switch (this.plcConnectionStatus) {
        case "Connected":
          return "PLC connection is active. " + last_checked_str;
        case "Disconnected":
          return "PLC is disconnected from Ignition. " + last_checked_str;
        case "NoConnectionSetup":
          return "PLC connection not configured or not supported yet. " + last_checked_str;
        case "CheckFailed":
          return "Connection Check Failed. " + last_checked_str;
        default:
          return "PLC Connection Unknown. " + last_checked_str;
      }
    },
  },
  methods: {
    initTooltips() {
      const tooltipTriggerList = [].slice.call(this.$el.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.forEach(el => {
        if (el._tooltip) {
          el._tooltip.dispose();
        }
        el._tooltip = new Tooltip(el);
      });
    },
    handleClick() {
      this.$router.push({
        name: "SteelCaseDashboard",
        params: { lineId: this.lineId },
      });
    },
  },
};
</script>
<i18n>
  {
    "EN": {
        "Line Name":"Line Name",
        "Created":"Created",
    },
    "DE": {
        "Line Name":"Linienname",
        "Created":"Erstellt",
    },
    "ES": {
        "Line Name":"Nombre de la Línea",
        "Created":"Creada",
    },
    "FR": {
        "Line Name":"Nom de la Ligne",
        "Created":"Créée",
    },
    "IT": {
        "Line Name":"Nome della Linea",
        "Created":"Creata",
    },
    "PL": {
        "Line Name":"Nazwa Linii",
        "Created":"Utworzony",
    },
    "TR": {
        "Line Name":"Hat İsmi",
        "Created":"Oluşturuldu",
    },
    "ZH": {
        "Line Name":"线路名称",
        "Created":"创建",
    },
  }
</i18n>
